import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import SENSORS from '@/constants/sensor';
import Styles from './index.module.scss';

const PageShare = ({ className, pageSlug, pageTitle, shareInfo, onSensorTrack }) => {
  const { title, description, icon, wxIcon } = shareInfo;

  const onShare = async () => {
    const params = {
      title,
      desc: description,
      url: `${window.location.href.split('?')[0]}?pageSlug=${pageSlug}`,
      coverUrl: wxIcon,
    };
    onSensorTrack(SENSORS.LIGHT_H5_SHARE_CLICK, {
      model_tab: pageTitle,
    });
    const { share } = await import('@/jsBridge/sdk');
    share(params);
  };

  return (
    <div
      className={cx(Styles.root, className)}
      style={{ backgroundImage: `url(${icon})` }}
      aria-hidden
      onClick={onShare}
    />
  );
};

PageShare.propTypes = {
  className: PropTypes.string,
  pageSlug: PropTypes.string,
  pageTitle: PropTypes.string,
  shareInfo: PropTypes.shape({}),
  onSensorTrack: PropTypes.func,
};

PageShare.defaultProps = {
  className: '',
  pageSlug: '',
  pageTitle: '',
  shareInfo: {},
  onSensorTrack: () => true,
};

export default PageShare;
